export default "<!-- <div class=\"blue-dot mat-elevation-z2\"></div> \n<map-widgets *ngIf=\"view\" [view]=\"view\"></map-widgets> -->";